import { payloads } from './schemas';

export const DASHBOARD_COMMAND_SCHEMAS = [
  { name: 'ADD_VARIABLE', payloadSchema: payloads.addVariable },
  { name: 'REMOVE_VARIABLE', payloadSchema: payloads.removeVariable },
  { name: 'UPDATE_VARIABLE', payloadSchema: payloads.updateVariable },
  { name: 'LIST_VARIABLES', payloadSchema: payloads.listVariables },
  { name: 'ADD_ANNOTATION', payloadSchema: payloads.addAnnotation },
  { name: 'UPDATE_ANNOTATION', payloadSchema: payloads.updateAnnotation },
  { name: 'REMOVE_ANNOTATION', payloadSchema: payloads.removeAnnotation },
  { name: 'LIST_ANNOTATIONS', payloadSchema: payloads.listAnnotations },
  { name: 'ENTER_EDIT_MODE', payloadSchema: payloads.enterEditMode },
  { name: 'GET_LAYOUT', payloadSchema: payloads.getLayout },
  { name: 'ADD_ROW', payloadSchema: payloads.addRow },
  { name: 'REMOVE_ROW', payloadSchema: payloads.removeRow },
  { name: 'UPDATE_ROW', payloadSchema: payloads.updateRow },
  { name: 'MOVE_ROW', payloadSchema: payloads.moveRow },
  { name: 'ADD_TAB', payloadSchema: payloads.addTab },
  { name: 'REMOVE_TAB', payloadSchema: payloads.removeTab },
  { name: 'UPDATE_TAB', payloadSchema: payloads.updateTab },
  { name: 'MOVE_TAB', payloadSchema: payloads.moveTab },
  { name: 'MOVE_PANEL', payloadSchema: payloads.movePanel },
  { name: 'UPDATE_LAYOUT', payloadSchema: payloads.updateLayout },
  { name: 'ADD_PANEL', payloadSchema: payloads.addPanel },
  { name: 'UPDATE_PANEL', payloadSchema: payloads.updatePanel },
  { name: 'REMOVE_PANEL', payloadSchema: payloads.removePanel },
  { name: 'LIST_PANELS', payloadSchema: payloads.listPanels },
  { name: 'GET_PANEL_ERRORS', payloadSchema: payloads.getPanelErrors },
  { name: 'GET_DASHBOARD_INFO', payloadSchema: payloads.getDashboardInfo },
  { name: 'GET_METADATA_ANNOTATIONS', payloadSchema: payloads.getMetadataAnnotations },
  { name: 'UPDATE_METADATA_ANNOTATIONS', payloadSchema: payloads.updateMetadataAnnotations },
  { name: 'UPDATE_DASHBOARD_SETTINGS', payloadSchema: payloads.updateDashboardSettings },
  { name: 'GET_SPEC', payloadSchema: payloads.getSpec },
  { name: 'APPLY_SPEC', payloadSchema: payloads.applySpec },
  { name: 'RENDER_PLAN', payloadSchema: payloads.renderPlan },
  { name: 'END_PLANNING', payloadSchema: payloads.endPlanning },
] as const;
